(() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-card]')];
    const groups = [...root.querySelectorAll('[data-group]')];
    const tools = root.querySelector('.cy-tools');
    const input = root.querySelector('#cy-search');
    const buttons = [...root.querySelectorAll('[data-filter]')];
    const resets = [...root.querySelectorAll('[data-reset]')];
    const result = root.querySelector('[data-result]');
    const empty = root.querySelector('.cy-empty');
    if (!tools || !input || !result || !empty) return;
    const normal = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(root.dataset.locale);
    const entries = cards.map(card => ({card, text:normal(card.dataset.search || card.textContent)}));
    let category = 'all';
    const update = () => {
      const terms = normal(input.value.trim()).split(/\s+/).filter(Boolean);
      let count = 0;
      entries.forEach(({card,text}) => {
        const visible = (category === 'all' || card.dataset.category === category) && terms.every(term => text.includes(term));
        card.hidden = !visible;
        if (visible) count++;
      });
      groups.forEach(group => {group.hidden = ![...group.querySelectorAll('[data-card]')].some(card => !card.hidden);});
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
      result.textContent = `${count} ${count === 1 ? root.dataset.one : root.dataset.many}`;
      empty.hidden = count !== 0;
      resets[0].hidden = category === 'all' && !input.value;
    };
    buttons.forEach(button => button.addEventListener('click', () => {category=button.dataset.filter; update();}));
    input.addEventListener('input', update);
    resets.forEach(button => button.addEventListener('click', () => {category='all'; input.value=''; update(); input.focus();}));
    root.querySelectorAll('[data-choice]').forEach(link => link.addEventListener('click', () => {category=link.dataset.choice; input.value=''; update();}));
    const hash = location.hash.replace('#cy-','');
    if (['cims','topographic','relief','wider'].includes(hash)) category=hash;
    tools.hidden = false;
    update();
  };
  init(document.querySelector('#trobart-catalunya'));
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('#trobart-catalunya')));
})();
